export const SIZE = { default: 16, large: 20 };
